/**
 * eFax search filter only. Must match `searchAnonymousRecordFaxes` input enum.
 * Patient Profile document trees use their own lists (e.g. RECORD_TYPES).
 */
export const OUTPUT_DOCUMENT_CATEGORIES = [
  'Original Records',
  'Provider/Facility Notes',
  'Imaging',
  'Procedures',
  'Lab Results',
  'Pathology Results',
  'Medications',
  'Vitals',
  'Problems',
  'Allergies',
  'Family history',
  'Social history',
  'Vaccinations',
  'Providers',
  'Non-Medical Documents',
] as const;

export type OutputDocumentCategory =
  (typeof OUTPUT_DOCUMENT_CATEGORIES)[number];
